var React = require('react');

function SliderArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"slider-arrow-left__stroke","d":"m13 37-11-18 11-18","fill":"none","stroke":"#fff","strokeWidth":"5"}));
}

SliderArrowLeft.defaultProps = {"className":"slider-arrow-left","height":"38","viewBox":"0 0 16 38","width":"16"};

module.exports = SliderArrowLeft;

SliderArrowLeft.default = SliderArrowLeft;
